<svg 
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 12 14">
    <path d="M11.469 2.969q0.219 0.219 0.375 0.594t0.156 0.688v9q0 0.312-0.219 0.531t-0.531 0.219h-10.5q-0.312 0-0.531-0.219t-0.219-0.531v-12.5q0-0.312 0.219-0.531t0.531-0.219h7q0.312 0 0.688 0.156t0.594 0.375zM8 1.062v2.937h2.937q-0.078-0.227-0.172-0.32l-2.445-2.445q-0.094-0.094-0.32-0.172zM11 13v-8h-3.25q-0.312 0-0.531-0.219t-0.219-0.531v-3.25h-6v12h10zM3 6.25q0-0.109 0.070-0.18t0.18-0.070h5.5q0.109 0 0.18 0.070t0.070 0.18v0.5q0 0.109-0.070 0.18t-0.18 0.070h-5.5q-0.109 0-0.18-0.070t-0.070-0.18v-0.5zM8.75 8q0.109 0 0.18 0.070t0.070 0.18v0.5q0 0.109-0.070 0.18t-0.18 0.070h-5.5q-0.109 0-0.18-0.070t-0.070-0.18v-0.5q0-0.109 0.070-0.18t0.18-0.070h5.5zM8.75 10q0.109 0 0.18 0.070t0.070 0.18v0.5q0 0.109-0.070 0.18t-0.18 0.070h-5.5q-0.109 0-0.18-0.070t-0.070-0.18v-0.5q0-0.109 0.070-0.18t0.18-0.070h5.5z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-file-text-o.html